import { render, staticRenderFns } from "./GStudentRecordCompetencyScoreTransition.vue?vue&type=template&id=06157060&scoped=true&"
import script from "./GStudentRecordCompetencyScoreTransition.vue?vue&type=script&lang=ts&"
export * from "./GStudentRecordCompetencyScoreTransition.vue?vue&type=script&lang=ts&"
import style0 from "./GStudentRecordCompetencyScoreTransition.vue?vue&type=style&index=0&id=06157060&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06157060",
  null
  
)

export default component.exports